module.exports = __webpack_public_path__ + "_/node_modules/@reverbdotcom/commons/design-system/icons/core/plus-circle-f1ce7941986df0aef5c9b2d8bba2da23.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@reverbdotcom/commons/design-system/icons/core/plus-circle.svg
// module id = sVz4
// module chunks = 24